import React, { useState, useEffect, useContext } from "react";
import Button from "../../../components/_default/Button";
import Input from "../../../components/_default/Input";
import UserContext from "../../../services/context/userContext";
import "./DefineForm.scss";
import generateUnique from "../../../services/defaultFunctions/generateUnique";
import Icon from "../../../components/_default/Icon";
import { addFormItemAurum, addFormItemCoach } from "../../../services/firebase/firestore/saveData";
import { updateFormItemAurum, updateFormItemCoach } from "../../../services/firebase/firestore/updateData";
import Header from '../../../components/_default/Header'

function DefineForm({ ...props }) {
  const [question_type, set_question_type] = useState("Rating");
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  // const [text_type, set_text_type] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [formType, setFormType] = useState(props.history.location.state.type ? props.history.location.state.type : "intake_form");
  const [subFormType, setSubFormType] = useState(props.history.location.state.sub_type ? props.history.location.state.sub_type : false);
  const [update, setUpdate] = useState(false);
  const [question, set_question] = useState(
    props.history.location.state.item
      ? props.history.location.state.item
      : {
          question: "",
          id: generateUnique(1, 9),
          question_type: question_type,
        }
  );
  const question_types = ["Rating", "Text box", "Multiple select", "Single select"];
  const text_types = ["text", "number"];

  const user = useContext(UserContext);
  const from = props.location.state.from;
  const isAdmin = !(from === "aurum" && !user.admin && props.location.state.update);

  useEffect(() => {
    setUpdate(props.history.location.state.update);
    if (props.history.location.state.update || props.location.state.copy) {
      set_question_type(props.history.location.state.item.question_type);
      set_question(props.history.location.state.item);
    } else {
      set_question({
        question: "",
        id: generateUnique(1, 9),
        question_type: question_type,
      });
    }
  }, [props.location.state]);

  useEffect(() => {
    let _question = { ...question };
    _question.question_type = question_type;
    switch (question_type) {
      case "Text box":
        _question = { ..._question, input_type: _question.input_type ? _question.input_type : "text" };
        break;
      case "Rating":
        _question = { ..._question, min: _question.min ? _question.min : 0, max: _question.max ? _question.max : 10 };
        break;
      case "Multiple select":
        _question = { ..._question, option_questions: _question.option_questions ? _question.option_questions : [{ option: "" }] };
        break;
      case "Single select":
        _question = { ..._question, option_questions: _question.option_questions ? _question.option_questions : [{ option: "" }] };
        break;
      default:
        break;
    }
    set_question(_question);
    
  }, [question_type]);

  function addOption() {
    let _question = { ...question };
    _question.option_questions.push({ option: "" });
    set_question(_question);
  }

  function removeOption(idx) {
    let _question = { ...question };
    _question.option_questions.splice(idx, 1);
    set_question(_question);
  }

  function addSubQuestion(idx) {
    let _question = { ...question };
    _question.option_questions[idx].sub_question = { question: "", type: "text" };
    set_question(_question);
  }

  function removeSubQuestion(idx) {
    let _question = { ...question };
    _question.option_questions[idx].sub_question = false;
    set_question(_question);
  }

  function onChange(e) {
    let _question = { ...question };
    if (e.idx >= 0) {
      if (e.sub) {
        _question.option_questions[e.idx].sub_question[e.type] = e.value;
      } else {
        _question.option_questions[e.idx][e.type] = e.value;
      }
    } else {
      _question[e.type] = e.value;
    }
    set_question(_question);
  }

  function initiateLoading(type, value) {
    if (type === "duplicate") {
      setLoadingDuplicate(value);
    } else {
      setLoading(value);
    }
  }

  function onSubmit(duplicate) {
    initiateLoading(duplicate ? "duplicate" : "save", true);
    if (question.question === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "name", message: "Fill in your question." });
    } else {
      if (from === "coach" || !user.admin) {
        if (update) {
          updateFormItemCoach(user.id, formType, subFormType, question, (result) => {
            initiateLoading(duplicate ? "duplicate" : "save", false);
            saveCallback(result, duplicate);
          });
        } else {
          addFormItemCoach(user.id, formType, subFormType, question, (result) => {
            initiateLoading(duplicate ? "duplicate" : "save", false);
            saveCallback(result, duplicate);
          });
        }
      } else {
        if (update) {
          updateFormItemAurum(formType, subFormType, question, (result) => {
            initiateLoading(duplicate ? "duplicate" : "save", false);
            saveCallback(result, duplicate);
          });
        } else {
          addFormItemAurum(formType, subFormType, question, (result) => {
            initiateLoading(duplicate ? "duplicate" : "save", false);
            saveCallback(result, duplicate);
          });
        }
      }
    }
  }

  function saveCallback(result, duplicate) {
    if (result) {
      if (duplicate) {
        let _item = { ...props.history.location.state.item };
        _item.id = generateUnique(1, 9);
        set_question_type(question_types[0])
        props.history.push("/form", { type: props.location.state.type, sub_type: props.location.state.sub_type, update: false, from: from });
      } else {
        props.history.push("/forms/" + (subFormType ? subFormType : formType).toString());
      }
    } else {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "default", message: "An unexpected error occurred while adding this question." });
    }
  }

  function copyToCoach() {
    let _item = { ...props.history.location.state.item };
    _item.id = generateUnique(1, 9);
    props.history.push("/form", { type: props.location.state.type, sub_type: props.location.state.sub_type, update: false, copy: true, from: "coach", item: _item });
  }

  function renderOptionSelect() {
    return (
      <>
        <div className="c-question">
          {question.option_questions &&
            question.option_questions.map((item, idx) => (
              <>
                <div key={idx} className="c-option">
                  {isAdmin ? (
                    <>
                      <Icon icon="check" />
                      <Input type="text" label={"Option " + (idx + 1)} placeholder={"Option " + (idx + 1)} value={item.option} onChange={(e) => onChange({ idx: idx, type: "option", value: e })} />
                      {!item.sub_question && (
                        <div className="c-option-icon --active" onClick={() => addSubQuestion(idx)}>
                          <Icon icon="plus-circle" size={18} />
                        </div>
                      )}
                      <div className="c-option-icon" onClick={() => removeOption(idx)}>
                        <Icon icon="trash" size={16} />
                      </div>{" "}
                    </>
                  ) : (
                    <>
                      <div className="c-check-no-admin">
                        <Icon icon="check" />
                      </div>
                      <div className="c-no-admin-subquestion-replace">
                        <span>{"Option " + (idx + 1)}</span>
                        <p>{item.option}</p>
                      </div>
                    </>
                  )}
                </div>
                {item.sub_question && (
                  <div key={idx} className="c-option --sub">
                    <div className="c-next-option">
                      <Icon icon="next-option" size={60} />
                    </div>
                    {isAdmin ? (
                      <>
                        <div className="c-sub-option">
                          <Input type="text" label={"Sub Question"} placeholder={"Sub Question"} value={item.sub_question.question} onChange={(e) => onChange({ idx: idx, sub: true, type: "question", value: e })} />
                          <Input type="select" label="Answer type" value={item.sub_question.type} options={text_types} onChange={(e) => onChange({ idx: idx, sub: true, type: "type", value: e })} />
                        </div>
                        <div className="c-option-icon" onClick={() => removeSubQuestion(idx)}>
                          <Icon icon="trash" size={16} />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="c-sub-option --no-admin">
                          <div className="c-no-admin-input-replace">
                            <span>Sub Question</span>
                            <p>{item.sub_question.question}</p>
                          </div>
                          <div className="c-no-admin-input-replace" style={{ minWidth: "80px" }}>
                            <span>Answer type</span>
                            <p>{item.sub_question.type}</p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </>
            ))}
        </div>
        {isAdmin && (
          <button className="c-add-content-btn" style={{backgroundColor:"#BBD0D3", color: "#2F727C"}} onClick={() => addOption()}>
            Add Option
          </button>
        )}
      </>
    );
  }

  return (
    <div className="c-page-wrapper" style={{flexFlow: 'column', justifyContent: 'flex-start'}}>
      <Header title={update ? "Update Question" : "Add Question"} subtitle={true} />
      <div className="c-page-main c-define-page c-define-wrapper c-page-details">
        <div className="c-page-forms">
          <h3 style={{ textTransform: "capitalize" }}>{update ? "Update " : "Add "} Question</h3>
        </div>
        {isAdmin ? (
          <div className="c-select-collection">
            <Input type="select" label="Question type" value={question_type} options={question_types} onChange={(e) => set_question_type(e)} />
          </div>
        ) : (
          <div className="c-no-admin-input-replace">
            <span>Form type</span>
            <p>{question_type}</p>
          </div>
        )}

        <div className={question_type === "Text box" || question_type === "Rating" ? "c-add-question-box --flex" : "c-add-question-box"} style={isAdmin ? {} : { flexDirection: "column" }}>
          {isAdmin ? (
            <Input label="Question" placeholder="On a scale of 1-10, how high would you rate having a healthy breakfast?" value={question.question} onChange={(e) => onChange({ type: "question", value: e })} error={error && error.type === "name" ? error.message : false} />
          ) : (
            <div className="c-no-admin-input-replace">
              <span>Question</span>
              <p>{question.question}</p>
            </div>
          )}
          {(() => {
            switch (question_type) {
              case "Text box":
                return (
                  <>
                    {isAdmin ? (
                      <div className="c-text-box-type">
                        <Input type="select" label="Answer type" value={question.input_type} options={text_types} onChange={(e) => onChange({ type: "input_type", value: e })} />
                      </div>
                    ) : (
                      <div className="c-no-admin-input-replace">
                        <span>Answer type</span>
                        <p>{question.input_type}</p>
                      </div>
                    )}
                  </>
                );
              case "Rating":
                return (
                  <>
                    {isAdmin ? (
                      <div className="c-rating">
                        <Input className="c-rating--width" type="number" min={0} max={10} placeholder="0" label="Min." value={question.min} onChange={(e) => onChange({ type: "min", value: e })} />
                        <Input className="c-rating--width" type="number" min={0} max={10} placeholder="10" label="Max." value={question.max} onChange={(e) => onChange({ type: "max", value: e })} />
                      </div>
                    ) : (
                      <div className="c-rating-admin-replace">
                        <div className="c-no-admin-input-replace">
                          <span>Min.</span>
                          <p>{question.min}</p>
                        </div>
                        <div className="c-no-admin-input-replace">
                          <span>Max.</span>
                          <p>{question.max}</p>
                        </div>
                      </div>
                    )}
                  </>
                );
              case "Multiple select":
                return renderOptionSelect();
              case "Single select":
                return renderOptionSelect();

              default:
                break;
            }
          })()}
        </div>
        {isAdmin && (
          <div className="c-button-collection" style={{alignItems: "center"}}>
            <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(false)} loading={loading} />
            {/* <Button text="Save and add another" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(true)} loading={loadingDuplicate} /> */}
            <p className="c-cancel-button" onClick={() => window.history.back()}>Cancel</p>
          </div>
        )}
        {from === "aurum" && !user.admin && props.location.state.update && (
          <div className="c-copy-workout-btn">
            <Button text="Copy question" color="#fff" backgroundColor="#00BDA5" onSubmit={() => copyToCoach()} loading={loading} />
          </div>
        )}
          {error && error.type === "default" && <p className="c-default-error-message">{error.message}</p>}
      </div>
      
      {/* {showPopup && (
        <Popup
          title={"Remove set"}
          button="Remove"
          deletePopup={true}
          description={"Are you sure you want to remove this set? This can not be undone."}
          onAction={() => removeSet(showPopup.id)}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )} */}
    </div>
  );
}

export default DefineForm;
